import workspace from "../../workspace";
import COLOR_THEMES, {COLOR} from "../../../store/colorThemes";
import sqftConfig from "../../../store/sqftConfig";
import {
  APPLIANCE_LOWER_PART_IDS,
  APPLIANCE_UPPER_PART_IDS,
  CABINET_FILTER_NAMES,
  RENDER_TEMPLATES,
  SIDEBAR_BUTTONS_MENU,
  SIDEBAR_NAVIGATION_BATHROOM_CABINET_BUTTONS,
  SIDEBAR_NAVIGATION_BUTTONS,
  SIDEBAR_NAVIGATION_CABINET_BUTTONS, SQFT_FEATURES
} from "../../../../../constants";
import config from "../../../store/sqftConfig";
import sqftShapeManager from "../../../store/sqftShapeManager";
import RenderParts, {MEASUREMENT_FORMATS} from "../../../helpers/renderParts";
import RenderFigures from "../../../helpers/renderFigures";
import store from "../../../../../../../store";
import RenderCabinets from "../../../helpers/renderCabinets";
import {COLORS} from "../../../../../../../colorThemes";
import Config from "../../../../../../../config";
import ShapeHelper, {
  canShapeBeAutoShifted,
  getIsShapePlacedOnTheFloor,
  getIsShapePlacedOnTheWall
} from "../../../../../helpers/shapeHelper";
import {getPointField, getPointPositionOnShape} from "../../../../../helpers/sqftHelper";
import {getQtCatName} from "../../../../../helpers/sqftQuotesHelper";
import * as uuid from "uuid";
import workspaceControllers from "../../../store/workspaceControllers";
import {getCurrentLayout} from "../../../../../../appLayout";
import {HingesModel} from "../../../store/models/HingesModel";
import {getHandleFeatureGroupFromShape} from "../../../../../helpers/sqftHelperUi";
import {SHAPE_LAYOUTS} from "../../cabinet/cabinetShapes";
import {pickPulsedColor} from "../../../helpers/commonParts/blink";
//import {pickColor} from "../../../helpers/commonParts/blink";
import cabinetFeatureDragHelper from "../../../helpers/cabinetFeatureDragHelper";
import {isShapeTallCabinet} from "../../../../../helpers/cabinetBoxCompatibilityHelper";
import {
  getTallCabinetHandleQuantities,
  hasTallCabinetInteriorLayout,
} from "../../../../../helpers/tallCabinetInteriorHelper";

export const CABINET_LINE_ROLE = {
  BACK: 'back',
  FRONT: 'front',
  SIDE: 'side',
};

class ShapeCabinet {
  __shape;
  __crownMoldingFeatureId = null;
  //__attachedFeatures = new Map();
  __crownMoldingParams = {
    distance: 10
  }
  __cabinetInteriorLayout = null;
  __doorExtensionEnabled = false;

  constructor(shape) {
    this.__shape = shape;
  }

  getCabinetInteriorLayout = () => {
    return this.__cabinetInteriorLayout;
  }

  setCabinetInteriorLayout = (layout) => {
    this.__cabinetInteriorLayout = layout;
  }

  getDoorExtensionEnabled = () => {
    return this.__doorExtensionEnabled;
  }

  setDoorExtensionEnabled = (isEnabled) => {
    this.__doorExtensionEnabled = Boolean(isEnabled);
  }

  import = (data) => {
    if (data.cabinetInteriorLayout) {
      this.__cabinetInteriorLayout = data.cabinetInteriorLayout;
    }
    if (data.doorExtensionEnabled !== undefined) {
      this.__doorExtensionEnabled = Boolean(data.doorExtensionEnabled);
    }
    // if (data.attachedFeatures) {
    //   const parsedFeatures = JSON.parse(data.attachedFeatures);
    //   this.__attachedFeatures = new Map(Object.entries(parsedFeatures));
    // }
  }

  export = () => {
    return {
      width: this.__shape.getWidth(),
      height: this.__shape.getHeight(),
      depth: this.__shape.getDepth(),
      cabinetInteriorLayout: this.__cabinetInteriorLayout,
      doorExtensionEnabled: this.__doorExtensionEnabled,
      //attachedFeatures: JSON.stringify(Object.fromEntries(this.__attachedFeatures)),
    }
  }

  getShapeLayout = () => {
    return this.__shape.shapeParams.shapeLayout || this.__shape.shapeParams.layout;
  }

  getFallbackSideLineIndexes = () => {
    const lines = this.__shape.getLines();
    const backLineIndexes = this.getLineIndexesByRole(CABINET_LINE_ROLE.BACK);
    const frontLineIndexes = this.getLineIndexesByRole(CABINET_LINE_ROLE.FRONT);
    const nonSideLineIndexes = new Set([...backLineIndexes, ...frontLineIndexes]);

    return lines
      .map((_, lineIndex) => lineIndex)
      .filter(lineIndex => !nonSideLineIndexes.has(lineIndex));
  }

  getLineIndexesByRole = (role) => {
    const lines = this.__shape.getLines();
    const lastLineIndex = lines.length - 1;
    const shapeLayout = this.getShapeLayout();

    if (role === CABINET_LINE_ROLE.SIDE) {
      switch (shapeLayout) {
        case SHAPE_LAYOUTS.UpperDimondCorner:
        case SHAPE_LAYOUTS.LowerDimondCorner:
          return [1, 4];
        case SHAPE_LAYOUTS.UpperLCorner:
        case SHAPE_LAYOUTS.LowerLCorner:
          return [1, 4];
        case SHAPE_LAYOUTS.LowerDullangle:
        case SHAPE_LAYOUTS.LowerDualangle:
          return [0];
        case SHAPE_LAYOUTS.UpperDimondShape:
        case SHAPE_LAYOUTS.LowerDimondShape:
          return [1, 3];
        case SHAPE_LAYOUTS.LowerIroningBoard:
        case SHAPE_LAYOUTS.LowerIroningBoardLeft:
          return [1];
        case SHAPE_LAYOUTS.LowerIroningBoardRight:
          return [lastLineIndex];
        default:
          return this.getFallbackSideLineIndexes();
      }
    }

    if (role === CABINET_LINE_ROLE.BACK) {
      switch (shapeLayout) {
        case SHAPE_LAYOUTS.UpperDimondCorner:
        case SHAPE_LAYOUTS.LowerDimondCorner:
          return [0, lastLineIndex - 1];
        case SHAPE_LAYOUTS.UpperLCorner:
        case SHAPE_LAYOUTS.LowerLCorner:
          return [0, lastLineIndex];
        case SHAPE_LAYOUTS.LowerDullangle:
        case SHAPE_LAYOUTS.LowerDualangle:
          return [3];
        case SHAPE_LAYOUTS.UpperDimondShape:
        case SHAPE_LAYOUTS.LowerDimondShape:
          return [0, 4];
        case SHAPE_LAYOUTS.LowerIroningBoard:
        case SHAPE_LAYOUTS.LowerIroningBoardRight:
          return [0];
        case SHAPE_LAYOUTS.LowerIroningBoardLeft:
          return [0];
        default:
          return [0];
      }
    }

    // role === CABINET_LINE_ROLE.FRONT
    switch (shapeLayout) {
      case SHAPE_LAYOUTS.UpperDimondCorner:
      case SHAPE_LAYOUTS.LowerDimondCorner:
      case SHAPE_LAYOUTS.UpperLCorner:
      case SHAPE_LAYOUTS.LowerLCorner:
        return [2, 3];
      case SHAPE_LAYOUTS.LowerDullangle:
      case SHAPE_LAYOUTS.LowerDualangle:
        return [1, 2];
      case SHAPE_LAYOUTS.UpperDimondShape:
      case SHAPE_LAYOUTS.LowerDimondShape:
        return [2];
      case SHAPE_LAYOUTS.LowerIroningBoard:
      case SHAPE_LAYOUTS.LowerIroningBoardRight:
      case SHAPE_LAYOUTS.LowerIroningBoardLeft:
        return [];
      default:
        return [2];
    }
  }

  getLinesByRole = (role) => {
    const lines = this.__shape.getLines();

    return this.getLineIndexesByRole(role)
      .map(lineIndex => lines[lineIndex])
      .filter(Boolean);
  }

  prepareLineOnWorkspace = (line) => {
    const shapeCenter = ShapeHelper.getCenterPoint(this.__shape.getLines().map(shapeLine => shapeLine.from));

    return {
      shapeId: this.__shape.id,
      shapeCenter: getPointPositionOnShape(shapeCenter.x, shapeCenter.y, line.getParent()),
      from: getPointPositionOnShape(line.from.x, line.from.y, line.getParent()),
      to: getPointPositionOnShape(line.to.x, line.to.y, line.getParent())
    }
  }

  getFrontLines = () => {
    return this.getLinesByRole(CABINET_LINE_ROLE.FRONT);
  }

  getFrontLinesOnWorkspace = () => {
    return this.getFrontLines().map(this.prepareLineOnWorkspace);
  }

  getBackLines = () => {
    return this.getLinesByRole(CABINET_LINE_ROLE.BACK);
  }

  getBackLinesOnWorkspace = () => {
    return this.getBackLines().map(this.prepareLineOnWorkspace);
  }

  getSideLines = () => {
    return this.getLinesByRole(CABINET_LINE_ROLE.SIDE);
  }

  getSideLinesOnWorkspace = () => {
    return this.getSideLines().map(this.prepareLineOnWorkspace);
  }

  /**
   * Generate hinges for the shape
   * @param {Object} shape - The shape to add hinges to
   * @param {number} quantity - Number of hinges to add
   * @param {Object} hingeFeature - Optional specific hinge feature to use
   */
  generateHinges = (shape, quantity, hingeFeature = null) => {
    if (!quantity || quantity <= 0) {
      return;
    }

    const layout = getCurrentLayout();
    const hingesFeatureGroup = layout.getFeatureGroupByPartId(SQFT_FEATURES.hinge);

    if (!hingesFeatureGroup) {
      console.log('Hinges feature group not found');
      return;
    }

    // Use provided feature or choose default
    const selectedHingeFeature = hingeFeature || hingesFeatureGroup.activeFeature || hingesFeatureGroup.features[0];

    if (!selectedHingeFeature) {
      console.log('No hinge feature available');
      return;
    }

    workspaceControllers.hinge.addResource(new HingesModel(
      shape.id,
      selectedHingeFeature.dbFeature.id,
      getQtCatName(),
      uuid.v4(),
      hingesFeatureGroup.partId,
      quantity
    ));
  };

  /**
   * Generate handles/knobs for the shape
   * @param {Object} shape - The shape to add handles to
   * @param {number} quantity - Number of handles to add (not used in current implementation)
   * @param {Object} handleFeature - Optional specific handle feature to use
   */
  generateHandles = (shape, quantity, handleFeature = null) => {
    if (!quantity || quantity <= 0) {
      return;
    }

    const handlesFeatureGroup = getHandleFeatureGroupFromShape(shape);

    if (!handlesFeatureGroup) {
      console.warn('Handles feature group not found for shape');
      return;
    }

    let selectedHandleFeature = handleFeature;

    // If no specific feature provided, determine which one to use
    if (!selectedHandleFeature) {
      const reduxState = store.getState();
      const selectedHandle = reduxState.sqftResourceState.selectedHandle;

      if (selectedHandle) {
        // Try to find the selected handle in the feature group
        selectedHandleFeature = handlesFeatureGroup.features.find(feature =>
          feature.getFeatureName() === selectedHandle.getFeatureName()
        );

        if (!selectedHandleFeature) {
          console.log(selectedHandle.getFeatureName() + " feature was not found in the featureGroup: " + handlesFeatureGroup.partName);
        }
      }

      // If still no feature, find one with 3D AR URLs
      if (!selectedHandleFeature) {
        selectedHandleFeature = handlesFeatureGroup.features.find(feature =>
          feature.dbFeature &&
          Array.isArray(feature.dbFeature.thirdPartyAR3DUrls) &&
          feature.dbFeature.thirdPartyAR3DUrls.length > 0
        );
      }
    }

    if (selectedHandleFeature) {
      workspaceControllers.handles.addHandleToTheShape(shape, selectedHandleFeature);
    } else {
      console.warn('No suitable handle feature found');
    }
  };

  /**
   * Main function to generate attached features for a shape
   * @param {Array} generatedFeatures - Array of feature types to generate
   * @param {Object} featureOverrides - Optional object with specific features to use
   *                                   Example: { hinges: hingeFeature, knobs: handleFeature }
   */
  generateAttachedFeatures = (generatedFeatures = Object.values(CABINET_FILTER_NAMES), featureOverrides = {}) => {
    const filtersToProcess = generatedFeatures;
    const { filterGroups } = store.getState().filterState;
    const feature = this.__shape.getFeature();

    if (!feature) {
      console.log('Shape has no feature');
      return;
    }

    // Loop through each filter defined in CABINET_FILTER_NAMES
    for (const key in CABINET_FILTER_NAMES) {
      const filterKey = CABINET_FILTER_NAMES[key];

      // Process only if the current filter is in the list of filters to process
      if (!filtersToProcess.includes(filterKey)) {
        continue;
      }

      // Retrieve the quantity for this filter
      let quantity = +feature.getFeatureSavedFilterName(filterGroups, filterKey, filterKey);

      if (filterKey === CABINET_FILTER_NAMES.knobs
        && isShapeTallCabinet(this.__shape)
        && hasTallCabinetInteriorLayout(this.__shape)
      ) {
        quantity = getTallCabinetHandleQuantities(this.__shape).total;
      }

      if (!quantity) {
        continue;
      }

      // Process hinges feature
      if (filterKey === CABINET_FILTER_NAMES.hinges) {
        this.generateHinges(this.__shape, quantity, featureOverrides.hinges);
      }

      // Process knobs/handles feature
      if (filterKey === CABINET_FILTER_NAMES.knobs) {
        this.generateHandles(this.__shape, quantity, featureOverrides.knobs);
      }
    }
  };

  // Function to delete attached features based on an optional array of filter values.
  // If the parameter is not provided, resources for all filters will be deleted.
  deleteAttachedFeatures = (deletedFeatures = Object.values(CABINET_FILTER_NAMES)) => {
    const filtersToDelete = deletedFeatures;

    // Delete hinges
    if (filtersToDelete.includes(CABINET_FILTER_NAMES.hinges)) {
      workspaceControllers.hinge.deleteAllResourcesForTheShape(this.__shape.id);
    }

    // Delete knobs
    if (filtersToDelete.includes(CABINET_FILTER_NAMES.knobs)) {
      workspaceControllers.handles.deleteAllResourcesForTheShape(this.__shape.id);
    }
  };

  addCrownMolding = () => {
    const state = store.getState();
    const selectedFeature = state.sqftResourceState.selectedFeature;
    this.__crownMoldingFeatureId = selectedFeature ? selectedFeature.part.dbFeature.id : null
    console.log("this.__crownMoldingFeatureId", this.__crownMoldingFeatureId);
  }

  render = (ctx, staticOffset = null, template= RENDER_TEMPLATES.default) => {
    if (workspace && workspace.getState().loading) return;
    let isShapeWithHandles = this.__shape.getLines().some(line => line.isWithHandle());

    const fillTemplate = this.getFillTemplate(ctx);
    this.renderBorders(ctx, staticOffset, template, fillTemplate);
    this.renderDimensionsInsideShape(ctx);
    RenderParts.drawShapeCrownMoldings(ctx, staticOffset, this.__shape);
    RenderParts.drawShapeEndCap(ctx, staticOffset, this.__shape);
    if (!isShapeWithHandles) this.renderFrontLines(ctx, staticOffset, template, fillTemplate);
    if (isShapeWithHandles) this.renderHandles(ctx);
    //if (!this.__shape.shapeAbsolute.getAbsolutePosition() && !this.__shape.shapeAbsolute.getSnappedWithShape()) {
    if (this.__shape.shapeAbsolute.getSnappedShapeGroup() === null) {
      //this.renderCrownMolding(ctx);
      this.renderDimensionsOutsideShape(ctx);
    }
    if (Config.isDevMode()) {
      this.renderTestShapeLines(ctx, staticOffset, template);
      this.renderShapeSnappedGroup(ctx, staticOffset, template);
    }
  }

  renderMeasurementArrows = (ctx) => {
    const points = this.__shape.getPointsPointField();
    RenderFigures.drawArrowsAroundPoints(ctx, points, 10);
  }

  renderTestShapeLines = (ctx) => {
    if (this.__shape.testShapeLines) {
      ctx.save();
      ctx.beginPath();
      ctx.lineWidth = 2;
      ctx.strokeStyle = COLORS.gray;
      for (const testShapeLine of this.__shape.testShapeLines) {
        ctx.moveTo(testShapeLine.from.x, testShapeLine.from.y);
        ctx.lineTo(testShapeLine.to.x, testShapeLine.to.y);
      }
      ctx.stroke();
      ctx.closePath();
      ctx.restore();
    }
  }

  renderShapeSnappedGroup = (ctx) => {
    // render shape group
    let shapeCenter = this.__shape.getCenter();
    const pos = getPointField(shapeCenter.x, shapeCenter.y, this.__shape);
    const renderText = this.__shape.shapeAbsolute.getSnappedShapeGroup() + ".gr";
    const mText = ctx.measureText(renderText);
    ctx.wrapText(renderText, pos.x, pos.y, mText, 22);
  }

  renderMeasurementLength = (ctx) => {
    const points = this.__shape.getPointsPointField();
    RenderParts.drawMeasurementAroundPoints(ctx, points, 3, MEASUREMENT_FORMATS.PRECISE);
  }

  renderDimensionsOutsideShape = (ctx) => {
    ctx.save();
    ctx.beginPath();
    this.renderMeasurementArrows(ctx);
    this.renderMeasurementLength(ctx);
    ctx.closePath();
    ctx.restore();
  }

  renderDimensionsInsideShape = (ctx) => {
    const shapeWidth = this.__shape.getWidth();
    const shapeHeight = this.__shape.getHeight();
    const textWidth = 'W: ' + shapeWidth;
    const textHeight = 'H: ' + shapeHeight;
    const fontSize = config.workspace.fontSizeSmallest;// * config.scale / config.defaultScale;
    const font = fontSize + "px " + config.activeFontRegular;
    const mTextWidth = ctx.measureText(textWidth);
    const mTextHeight = ctx.measureText(textWidth);
    const {minX, maxX, minY, maxY} = sqftShapeManager.getMinMaxShapePoints(this.__shape,true, true);
    void minY;
    //middle of the bottom line
    let pos = {
      x: minX + (maxX - minX) / 2 - mTextWidth.width / 2,
      y: maxY - fontSize - 10 //( frontLine circle)
    };

    // center position
    // let shapeCenter = ShapeHelper.getCenterPoint(points);
    // let shapeCenterOnField =  getPointField(shapeCenter.x, shapeCenter.y, this.__shape);
    // let pos = {
    //   x: shapeCenterOnField.x - mTextWidth.width / 2,
    //   y: shapeCenterOnField.y
    // };

    ctx.textAlign = "start";
    ctx.fillStyle = COLOR_THEMES[sqftConfig.activeTheme].primary_hover;

    const lineHeight = config.workspace.fontSizeSmallest;
    ctx.wrapText(textWidth, pos.x, pos.y - (fontSize / 2), mTextWidth, lineHeight, font);
    ctx.wrapText(textHeight, pos.x + 2, pos.y + (fontSize / 2), mTextHeight, lineHeight, font);
  }

  getFillTemplate = () => {
    const isBlinkActive = this.__shape.shapeRender.blink.isActive;
    const blinkProgress = this.__shape.shapeRender.blink.progress;
    const colorOverride = this.__shape.shapeRender.blink._colorOverride;

    // Helper to get base colors for different states
    const getBaseColors = () => {
      if (this.__shape.isDisabledInPopup) {
        return {
          stroke: COLOR.gray4_transparent,
          fill: COLOR.lightgray4_transparent,
          template: RENDER_TEMPLATES.disabled
        };
      }
      return {
        stroke: COLOR_THEMES[sqftConfig.activeTheme].primary,
        fill: COLOR_THEMES[sqftConfig.activeTheme].primary_transparent,
        template: RENDER_TEMPLATES.filledPrimary
      };
    };

    // Helper to get highlight colors based on override
    const getHighlightColors = () => {
      if (colorOverride === 'active') {
        return {
          stroke: COLOR_THEMES[sqftConfig.activeTheme].active_hover,
          fill: COLOR_THEMES[sqftConfig.activeTheme].active_transparent
        };
      } else if (colorOverride === 'red') {
        return {
          stroke: COLOR.red,
          fill: COLOR.red_transparent
        };
      }
      // Default highlight
      return {
        stroke: COLOR_THEMES[sqftConfig.activeTheme].primary_hover,
        fill: COLOR_THEMES[sqftConfig.activeTheme].active_transparent
      };
    };

    // If blink is active, return interpolated colors
    if (isBlinkActive) {
      const baseColors = getBaseColors();
      const highlightColors = getHighlightColors();

      return {
        stroke: pickPulsedColor(
          highlightColors.stroke,
          baseColors.stroke,
          blinkProgress
        ),
        fill: pickPulsedColor(
          highlightColors.fill,
          baseColors.fill,
          blinkProgress
        ),
        isCustomColor: true // Flag to tell drawShapeBorders to use colors directly
      };
    }

    return getBaseColors();
  };

  renderFrontLines = (ctx) => {
    const frontLines = this.getFrontLines();
    RenderParts.drawFrontLines(ctx, this.__shape, frontLines, true);
  }

  renderBorders = (ctx,
                   staticOffset = null,
                   strokeTemplate= RENDER_TEMPLATES.default,
                   fillTemplate = RENDER_TEMPLATES.filledPrimary
  ) => {
    RenderParts.drawShapeBorders(ctx, staticOffset, strokeTemplate, fillTemplate, this.__shape);

    // Highlight lines in cabinets mode
    const reduxState = store.getState();
    const activeButton = reduxState.sqftMenuState.activeButton;

    const isApplianceActive = SIDEBAR_NAVIGATION_BATHROOM_CABINET_BUTTONS.appliances === activeButton;
    if (activeButton === SIDEBAR_NAVIGATION_CABINET_BUTTONS.handles
      || activeButton === SIDEBAR_NAVIGATION_CABINET_BUTTONS.spacer
      || activeButton === SIDEBAR_NAVIGATION_CABINET_BUTTONS.crown_molding
      || activeButton === SIDEBAR_NAVIGATION_BUTTONS.end_cap
      || activeButton === SIDEBAR_NAVIGATION_CABINET_BUTTONS.end_panel
      || activeButton === SIDEBAR_NAVIGATION_CABINET_BUTTONS.resize
      || activeButton === SIDEBAR_BUTTONS_MENU.delete
    ) {
      if (
        config.highlight.linesWithShapePartIds.length === 0 || config.highlight.linesWithShapePartIds.includes(this.__shape.partId)
      ) {
        RenderParts.drawBorders(ctx, staticOffset, this.__shape.getLines(), true);
      }

    // Highlight possibility to insert shape between lines
    } else if (activeButton === SIDEBAR_NAVIGATION_CABINET_BUTTONS.upper
      || activeButton === SIDEBAR_NAVIGATION_CABINET_BUTTONS.lower
      || activeButton === SIDEBAR_NAVIGATION_CABINET_BUTTONS.tall
      || activeButton === SIDEBAR_NAVIGATION_BATHROOM_CABINET_BUTTONS.vanity
      || isApplianceActive
      || workspace.getMovingShape()
    ) {
      this.renderHighlightedLines(ctx, staticOffset);
    }
  };

  renderHighlightedLines = (ctx, staticOffset) => {
    const reduxState = store.getState();
    const menuOpened = reduxState.sqftMenuState.menuOpened;
    const activeButton = reduxState.sqftMenuState.activeButton;
    const movingShape = workspace.getMovingShape();
    const isSidebarTallCabinetDrag = !movingShape && cabinetFeatureDragHelper.isTallCabinetDrag(activeButton);

    const isTestShapePlacedOnTheFloor = getIsShapePlacedOnTheFloor(this.__shape);
    const isTestShapePlacedOnTheWall = getIsShapePlacedOnTheWall(this.__shape);

    const isMovingShapePlacedOnTheFloor = activeButton === SIDEBAR_NAVIGATION_CABINET_BUTTONS.lower
      || activeButton === SIDEBAR_NAVIGATION_CABINET_BUTTONS.tall
      || activeButton === SIDEBAR_NAVIGATION_BATHROOM_CABINET_BUTTONS.vanity
      || APPLIANCE_LOWER_PART_IDS.includes(menuOpened)
      || isSidebarTallCabinetDrag;

    const isMovingShapePlacedOnTheWall = activeButton === SIDEBAR_NAVIGATION_CABINET_BUTTONS.upper
      || APPLIANCE_UPPER_PART_IDS.includes(menuOpened)
      || isSidebarTallCabinetDrag;
    const canMovingShapeShuffleWithShape = movingShape
      && movingShape.shapeAutoShuffle
      && movingShape.shapeAutoShuffle.canShapeShuffleWithHoveredShape(movingShape, this.__shape);

    //1. Highlight moving shape if their part ids are equal
    //2. Highlight upper shapes if we are dragging new upper cabinet shape
    //3. Highlight lower shapes if we are dragging new lower cabinet shape
    //4. Highlight lower shapes if we are dragging new tall cabinet shape
    if (canMovingShapeShuffleWithShape
      || (movingShape && canShapeBeAutoShifted(workspace.getMovingShape(), this.__shape))
      || (isMovingShapePlacedOnTheWall && isTestShapePlacedOnTheWall)
      || (isMovingShapePlacedOnTheFloor && isTestShapePlacedOnTheFloor)
    ) {
      const style = {
        lineWidth: 4,
        strokeStyle: COLOR.red,
        shadowBlur: 2,
        extendHoveredLine: 5
      };
      RenderParts.drawBorders(ctx, staticOffset, this.__shape.getLines(), true, style);
    }
  }

  renderHandles = (ctx) => {
    const frontLines = this.getFrontLines();
    RenderParts.drawHandles(ctx, this.__shape, frontLines);
  };

  getCrownMoldingPoints = () => {
    const points = this.__shape.getPointsPointField();

    return RenderCabinets.getDiagonalPointsForTheSquare(points, this.__crownMoldingParams.distance)
  }

  // renderCrownMolding = (ctx) => {
  //   if (this.__crownMoldingFeatureId) {
  //     const crownMoldingPoints = this.getCrownMoldingPoints();
  //     RenderCabinets.renderCrownMolding(ctx, crownMoldingPoints);
  //   }
  // };
}

export default ShapeCabinet
